import { createFileRoute } from "@tanstack/react-router";

import TodosSort from "@/features/todos/todos-sort";

export const Route = createFileRoute(
  "/_authenticated/$company/buchhaltung/eingang/sort",
)({
  component: PayableSortPage,
  staticData: {
    breadcrumb: ["todos.payable.title"],
  },
});

function PayableSortPage() {
  return <TodosSort type="payable" />;
}
